import { call } from "redux-saga/effects";

export function* fetchAllPages(
  request,
  payload,
  normalizer,
  otherData,
  condition
) {
  let pageNum = 1;
  let response = yield call(request, pageNum, payload);
  let { data, meta } = normalizer(response.data);
  let items = [...data];
  while (meta.current_page < meta.last_page && condition) {
    pageNum = pageNum + 1;
    response = yield call(request, pageNum, payload);
    const { data, meta: meta1 } = normalizer(response.data);
    meta = meta1;
    items = [...items, ...data];
  }
  let otherPartOfData = {};
  if (otherData) {
    otherPartOfData = otherData(response);
  }
  return {
    ...otherPartOfData,
    data: items
  };
}

export const defaultNormalizerWithoutSeparateMetaObj = response => {
  const { data, ...meta } = response.data;
  return { data, meta };
};

export const defaultNormalizerWithSeparateMetaObj = response => {
  const { data, meta } = response;
  return { data, meta };
};
